<script lang="ts">
    import { dev } from "$app/environment"
    export let width = "100%"
    export let height = "100%"
    export let spin = false
    export let shadow = false

    // ellen secret
    import { ellen } from "$lib/data"
</script>

{#if $ellen}
    <div class="ellen spin" style:width style:height class:shadow />
{:else}
    <svg
        x="0px"
        y="0px"
        viewBox="0 0 1057.182 1057.179"
        enable-background="new 0 0 1057.182 1057.179"
        xml:space="preserve"
        style:width
        style:height
        class:shadow
        class="wheel"
        class:spin={!dev && spin}
    >
        <path
            fill="#DDC69C"
            d="M1057.182,528.587c0,291.936-236.658,528.592-528.591,528.592S0,820.523,0,528.587
            C0,236.657,236.658,0,528.591,0S1057.182,236.657,1057.182,528.587z"
        />
        <path
            fill="#F2DABD"
            d="M1026.594,528.587c0,275.042-222.966,498.004-498.003,498.004
            c-275.04,0-498.003-222.963-498.003-498.004c0-275.037,222.963-498,498.003-498C803.628,30.587,1026.594,253.55,1026.594,528.587z"
        />
        <path
            fill="#F7941E"
            d="M406.021,71.154c-81.489,21.782-154.333,64.726-212.237,122.627l334.807,334.805
            L406.021,71.154z"
        />
        <path
            fill="#F15A29"
            d="M193.784,193.782C135.882,251.686,92.938,324.53,71.155,406.021l457.436,122.566
            L193.784,193.782z"
        />
        <path
            fill="#F9ED32"
            d="M651.157,71.154c-39.096-10.45-80.175-16.054-122.566-16.054
            c-42.393,0-83.471,5.604-122.569,16.054l122.569,457.433L651.157,71.154z"
        />
        <path
            fill="#009444"
            d="M986.022,406.021c-21.779-81.491-64.725-154.335-122.628-212.239L528.591,528.587
            L986.022,406.021z"
        />
        <path
            fill="#00A79D"
            d="M986.022,651.158c10.451-39.096,16.057-80.176,16.057-122.571
            c0-42.391-5.605-83.468-16.057-122.566L528.591,528.587L986.022,651.158z"
        />
        <path
            fill="#8DC63F"
            d="M863.395,193.782C805.493,135.88,732.65,92.937,651.157,71.154L528.591,528.587
            L863.395,193.782z"
        />
        <path
            fill="#BE1E2D"
            d="M71.155,406.021c-10.449,39.098-16.052,80.175-16.052,122.566
            c0,42.395,5.603,83.475,16.052,122.571l457.436-122.571L71.155,406.021z"
        />
        <path
            fill="#27AAE1"
            d="M528.591,528.587l334.804,334.807c57.903-57.902,100.849-130.744,122.628-212.236
            L528.591,528.587z"
        />
        <path
            fill="#2B3990"
            d="M406.021,986.023c39.099,10.451,80.177,16.053,122.569,16.053
            c42.392,0,83.471-5.602,122.566-16.053L528.591,528.587L406.021,986.023z"
        />
        <path
            fill="#1C75BC"
            d="M651.157,986.023c81.493-21.779,154.336-64.725,212.237-122.629L528.591,528.587
            L651.157,986.023z"
        />
        <path
            fill="#9E1F63"
            d="M71.155,651.158c21.782,81.492,64.727,154.334,122.629,212.236l334.807-334.807
            L71.155,651.158z"
        />
        <path
            fill="#662D91"
            d="M193.784,863.394c57.904,57.904,130.748,100.85,212.237,122.629l122.569-457.436
            L193.784,863.394z"
        />
        <circle fill="#F2DABD" cx="528.591" cy="528.587" r="41.603" />
        <path
            fill="#58595B"
            d="M555.707,528.587c0,14.979-12.142,27.12-27.116,27.12c-14.976,0-27.116-12.141-27.116-27.12
            c0-14.974,12.141-27.113,27.116-27.113C543.565,501.474,555.707,513.613,555.707,528.587z"
        />
    </svg>
{/if}

<style>
.ellen {
  background-image: url(/images/ellen.jpg);
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-size: cover;
}

.wheel, .ellen {
  animation-duration: 50000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.wheel.spin, .ellen.spin {
  animation-name: spin;
}
.wheel.shadow, .ellen.shadow {
  filter: drop-shadow(0px 0px 10px hsla(234, 100%, 75.9%, 0.2));
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
